import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import DentalNews from '../../components/Panel/DentalNews/DentalNews';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    tituloPagina2: {
      fontSize: 20,
      fontWeight: 'bold',
      textAlign: 'center',
      width:'100%'
    },
    divCenter: {
      textAlign: 'center'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    },
    username: localStorage.getItem("dental_n")
  };

const DentalNewspage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
        </div>
        
        <h3 style={globalStyles.navigation}>
          Novidades da
          <span style={styles.tituloPagina}> Dental</span>
        </h3>

        <DentalNews />

      </div>
    </Panel>

  );
};

export default DentalNewspage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/DentalNewspage.js
 **/